import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalesService } from 'src/app/services/globales.service';
import { MainService } from 'src/app/api/main.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ComponentsModule } from 'src/app/modules/components.module';

@Component({
  selector: 'app-login-control',
  standalone: true,
  imports: [
    ComponentsModule
  ],
  templateUrl: './login-control.component.html',
  styleUrls: ['./login-control.component.scss'],
})
export class LoginControlComponent {

  //#region Propiedades

  @ViewChild("username") public txtUserName: HTMLInputElement
  @Output("loggedIn") public loggedIn = new EventEmitter<void>()
  public errorMessage: string

  //#endregion

  //#region Constructor

  constructor(
    public globales: GlobalesService,
    private fb: FormBuilder,
    private service: MainService
  ) { }

  //#endregion

  //#region Formulario

  public form = this.fb.group({
    UserName: ['', Validators.required],
    Password: ['', Validators.required]
  })

  //#endregion

  //#region Login

  public async login(): Promise<void> {
    if (this.form.valid) {
      try {
        let result = await this.service.Login.Login(this.form.getRawValue())
        if (result != null) {
          localStorage.setItem('token', result)
          this.service.loginToken = result
          
          // Ocultamos el mensaje de error
          this.errorMessage = null

          // Notificamos de que el inicio de sesión ha sido satisfactorio
          this.loggedIn.emit()

        } else {
          this.errorMessage = 'No se ha podido iniciar sesión.'
        }
      } catch (ex) {
        this.errorMessage = ex?.message || 'Ha ocurrido un error al iniciar sesión.'
      }
    }
  }

  //#endregion

  //#region Visibilidad contraseña

  public toggleVisibility(input: HTMLInputElement) {
    input.type = input.type == 'password' ? 'text' : 'password'
  }

  //#endregion

}
